import MaterialSymbol from "./MaterialSymbol"

export default function IconButton({name, transparent=true, src, icon, className, isActive=false, onClick}) {
  return (
    <button
      onClick={onClick}
      title={name}
    >
      {src ?
        <img
          className={`${className} ${isActive ? "text-white bg-white/40": ""} ${transparent ? "hover:opacity-60" : "backdrop-blur-sm hover:bg-white/40"} p-1.5 rounded-full hover:text-white pointer-events-auto`}
          src={src}
        />
        :
        <MaterialSymbol
          className={`${className} ${isActive ? "text-white bg-white/40": ""} ${transparent ? "hover:opacity-60" : "backdrop-blur-sm hover:bg-white/40"} p-1.5 rounded-full hover:text-white pointer-events-auto`}
          name={icon}
        />
      }
    </button>
  )
}
